import { useForm } from "react-hook-form";
import { NavLink } from "react-router-dom";
import Facebook from "../../../public/images/Facebook";
import Logo from "../../../public/images/Logo";
import Twitter from "../../../public/images/Twitter";
import Youtube from "../../../public/images/Youtube";
import "./footer.scss";

export default function Footer() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    console.log("FORM DATA:", data);
  };
  return (
    <footer>
      <div className="footerTop">
        <div className="footerTop__logo">
          <Logo />
        </div>
        <div className="footerTop__about">
          <h2>Company</h2>
          <NavLink to="/warranties">Warranties</NavLink>
          <NavLink to="/sla">SLA</NavLink>
          <NavLink to="/agreements">Agreements</NavLink>
          <NavLink to="/termsConditions">Terms&Conditions</NavLink>
        </div>
        <div className="footerTop__contacts">
          <h2>Contacts</h2>
          <a href="tel:+37378666677" target="_blank">
            +373-78-6666-77
          </a>
          <a href="mail:info@x-cloud.info" target="_blank">
            info@x-cloud.info
          </a>
          <a href="https://maps.app.goo.gl/xoSJ4gobUvqMvzfc6" target="_blank">
            Kalya Orheiului 20/1, Chisinau Moldova
          </a>
        </div>
        <div className="footerTop__develop">
          <h2>Development</h2>
          <a
            href="/images/voicex_api.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            API
          </a>
        </div>
        <div className="footerTop__join">
          <h2>Join our Commumity</h2>
          <form onSubmit={handleSubmit(onSubmit)}>
            <input
              placeholder="Email"
              {...register("email", {
                required: "Email is required",
                pattern: {
                  value: /\S+@\S+\.\S+/,
                  message: "Invalid email address",
                },
              })}
            />
            {errors.email && <p>{errors.email.message}</p>}
            <button type="submit">Send</button>
          </form>
          <div className="footerTop__join__links">
            <a href="">
              <Twitter />
            </a>
            <a
              href="https://www.facebook.com/xcloudcompany/"
              target="_blank"
              defer
            >
              <Facebook />
            </a>
            <a href="">
              <Youtube />
            </a>
          </div>
        </div>
      </div>
      <div className="footerBottom">
        <span>2008 X-Cloud Solutions. All rights reserved</span>
      </div>
    </footer>
  );
}
